import { animate, resize, steps } from 'motion';

const element = document.querySelector('.announcement-bar');

if (element) {
  const announcements = element.querySelectorAll<HTMLElement>('.announcement');

  const animation = animate(
    announcements,
    {
      y: [0, `-${announcements.length * 2}lh`],
    },
    {
      duration: announcements.length * 3, // 3 seconds per announcement.
      repeatType: 'loop',
      ease: steps(announcements.length, 'end'),
      repeat: Infinity,
    }
  );

  animation.pause();

  resize(element, (_, info) => {
    if (info.width >= 1024) {
      animation.cancel();
    } else {
      animation.play();
    }
  });
}
